import {
  buildProps,
  definePropType,
  isNumber,
  isString,
  mutable,
} from '@jdesign-vue/utils'
import { CHANGE_EVENT, UPDATE_MODEL_EVENT } from '@jdesign-vue/constants'
import type { ExtractPropTypes } from 'vue'
import type { Arrayable } from '@jdesign-vue/utils'

export type CollapseActiveName = string | number
export type CollapseModelValue = Arrayable<CollapseActiveName>

export const emitChangeFn = (value: CollapseModelValue) =>
  typeof isNumber(value) || isString(value) || Array.isArray(value)

export type CollapseExpandIconPosition = 'start' | 'end'

export const collapseProps = buildProps({
  accordion: Boolean,
  modelValue: {
    type: definePropType<CollapseModelValue>([Array, String, Number]),
    default: () => mutable([] as const),
  },
  /**
   * @description 控制展开/折叠图标的位置：'end' 在最右侧（默认），'start' 在最左侧
   */
  expandIconPosition: {
    type: definePropType<CollapseExpandIconPosition>(String),
    values: ['start', 'end'],
    default: 'end',
  },
} as const)
export type CollapseProps = ExtractPropTypes<typeof collapseProps>

export const collapseEmits = {
  [UPDATE_MODEL_EVENT]: emitChangeFn,
  [CHANGE_EVENT]: emitChangeFn,
}
export type CollapseEmits = typeof collapseEmits
